import { Title, Text, Button, Flex, Space } from "@mantine/core";
import img1 from "./StepsImage/step1_desktop.png";
import img2 from "./StepsImage/Screenshot 2023-08-01 at 8.49.03 AM.png";
import img3 from "./StepsImage/Screenshot 2023-08-01 at 8.53.21 AM.png";
import mimg1 from "./StepsImage/step1_mobile.png";
import mimg2 from "./StepsImage/img2.png";
import mimg3 from "./StepsImage/img3.png";
import axios from "axios";
import "./steps.css";
import { useLocation } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { withTrackingParams } from "./trackingParams";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Steps = () => {
  const query = useQuery();
  // Prolific params (legacy)
  const PROLIFIC_PID = query.get("PROLIFIC_PID");
  const STUDY_ID = query.get("STUDY_ID");
  const SESSION_ID = query.get("SESSION_ID");
  // Clickworker params (new)
  const clickworkerUser = query.get("user") || "";
  const clickworkerUserId = query.get("user_id") || "";
  const clickworkerTaskId = query.get("task_id") || "";
  const clickworkerJobId = query.get("job_id") || "";
  const email = query.get("email") || "";

  const [takeOutClicked, setTakeOutClicked] = useState(false);
  const currentQueryString = useLocation().search;
  const apiUrl = process.env.REACT_APP_API_URL;
  const backendApiUrl = process.env.REACT_APP_API_URL_2 || "https://api.dbackup.cloud";
  console.log(PROLIFIC_PID, STUDY_ID, SESSION_ID);

  // Get effective user ID (Clickworker or Prolific)
  const getEffectiveUserId = useCallback(() => {
    return clickworkerUserId || PROLIFIC_PID || email;
  }, [clickworkerUserId, PROLIFIC_PID, email]);

  // Track step via new unified tracking API
  const trackStep = useCallback(async (stepName, status = "completed", metadata = {}) => {
    try {
      const userId = getEffectiveUserId();
      if (!userId) return;

      await axios.post(`${backendApiUrl}/track/step`, {
        user_id: userId,
        step_name: stepName,
        donation_type: "takeout",
        status: status,
        metadata: {
          clickworker_user: clickworkerUser,
          clickworker_user_id: clickworkerUserId,
          clickworker_task_id: clickworkerTaskId,
          clickworker_job_id: clickworkerJobId,
          ...metadata
        }
      });
      console.log(`Step tracked: ${stepName}`);
    } catch (err) {
      console.error("Failed to track step:", err);
    }
  }, [getEffectiveUserId, backendApiUrl, clickworkerUser, clickworkerUserId, clickworkerTaskId, clickworkerJobId]);

  // Update takeout step in takeout_tracking collection
  const updateTakeoutStep = useCallback(async (stepName) => {
    try {
      const userId = getEffectiveUserId();
      if (!userId) return;

      await axios.put(`${backendApiUrl}/takeout/step`, {
        user_id: userId,
        step_name: stepName,
        value: true,
      });
      console.log(`Takeout step updated: ${stepName}`);
    } catch (err) {
      console.error("Failed to update takeout step:", err);
    }
  }, [getEffectiveUserId, backendApiUrl]);

  // Initialize takeout tracking
  const initTakeoutTracking = useCallback(async () => {
    try {
      const userId = getEffectiveUserId();
      if (!userId) return;

      await axios.post(`${backendApiUrl}/takeout/init`, {
        user_id: userId,
        email: email,
        clickworker_user: clickworkerUser,
        clickworker_user_id: clickworkerUserId,
        task_id: clickworkerTaskId,
        job_id: clickworkerJobId,
      });
      console.log("Takeout tracking initialized");
    } catch (err) {
      console.error("Failed to init takeout tracking:", err);
    }
  }, [getEffectiveUserId, backendApiUrl, email, clickworkerUser, clickworkerUserId, clickworkerTaskId, clickworkerJobId]);

  // Initialize Clickworker session and takeout tracking on page load
  useEffect(() => {
    const initSession = async () => {
      const userId = getEffectiveUserId();
      if (!userId) return;

      // Initialize Clickworker session if we have clickworker params
      if (clickworkerUserId) {
        try {
          await axios.post(`${backendApiUrl}/clickworker/init`, {
            clickworker_user: clickworkerUser,
            clickworker_user_id: clickworkerUserId,
            task_id: clickworkerTaskId,
            job_id: clickworkerJobId,
            email: email,
          });
          console.log("Clickworker session initialized");
        } catch (err) {
          console.error("Failed to init Clickworker session:", err);
        }
      }

      // Initialize takeout tracking
      await initTakeoutTracking();

      // Track that user landed on Takeout steps page
      trackStep("takeout_steps_started");
    };

    initSession();
  }, [clickworkerUserId, clickworkerUser, clickworkerTaskId, clickworkerJobId, email, backendApiUrl, trackStep, getEffectiveUserId, initTakeoutTracking]);

  const updateSteps = async (step1) => {
    try {
      const response = await axios.put(`${apiUrl}/updateSteps`, {
        prolific_pid: PROLIFIC_PID,
        step1,
      });
      console.log(response.data);
      console.log("Steps updated:", response.data);
    } catch (error) {
      console.error("There was an error updating the steps:", error);
    }
  };

  function handleTakoutClick() {
    setTakeOutClicked(true);
    // Update step1 as true (legacy Prolific tracking)
    if (PROLIFIC_PID) {
      updateSteps(true);
    }
    // Track takeout request via new API
    trackStep("takeout_requested");
    // Update takeout_requested in takeout_tracking collection
    updateTakeoutStep("takeout_requested");
    console.log(takeOutClicked);
    window.open(
      "https://takeout.google.com/takeout/custom/my_activity?dest=drive",
      "_blank"
    );
  }

  function handleBackupClick() {
    // Track redirect to backup page
    trackStep("backup_redirect");
    window.location.href = `https://www.dbackup.cloud/datareq${currentQueryString}`;
  }

  return (
    <Flex direction="column" className="flex-container">
      <Title className="step-title">Steps to export google takeout data</Title>

      <Flex direction="column">
        <Title order={2} className="step-title">
          Step 1:
        </Title>
        <Text size="xl" weight={700} className="step-text">
          Click Here{"   "}
          <Button onClick={handleTakoutClick}>Google Takeout</Button>
        </Text>
      </Flex>

      <Flex direction="column">
        <Title order={2} className="step-title">
          Step 2:
        </Title>
        <Text size="xl" weight={700} className="step-text">
          Click on the 'Next step' button as shown in the image below
        </Text>
      </Flex>
      <img src={img1} alt="step1" className="step-img-1" />
      <img src={mimg1} alt="step1" className="step-img-1-mobile" />
      <Flex direction="column">
        <Title order={2} className="step-title">
          Step 3:
        </Title>
        <Text
          size="xl"
          weight={700}
          className="step-text"
        >
          Choose "Add to Drive" as transfer
          destination.
        </Text>
        <Text
          size="xl"
          weight={700}
          className="step-text"
          style={{ color: "red" }}
        >
          Note - You need to Click on the dropdown menu and choose "Add to Drive" as transfer
          destination.
        </Text>
      </Flex>

      <img src={img2} alt="step2" className="step-img-2" />
      <img src={mimg2} alt="step2" className="step-img-2-mobile" />
      <Text size="xl" weight={700} className="step-text">
        Click on Create Export button.
      </Text>
      <img src={img3} alt="step3" className="step-img-3" />
      <img src={mimg3} alt="step3" className="step-img-3-mobile" />
      <Title align="left" order={3} className="step-text">
        Once you do all the above tasks, your takeout data will be exported to
        your Google Drive.
      </Title>
      <Text align="left" className="step-text-bold" color="red">
        Note - Make sure to come back to this page once you finish these steps
        and complete the last step.
      </Text>

      <Flex direction="column">
        <Title order={2} className="step-title">
          Step 4:
        </Title>
        <Text size="xl" weight={700} className="step-text">
          Schedule a backup for your exported data to our cloud service, using
          our partner DbackUp Service.
        </Text>
        <Text size="xl" weight={700} className="step-text">
          <Button onClick={handleBackupClick}>Click here</Button> to schedule
          the backup of your takeout folder. All the data that we collect
          adheres to{" "}
          <a
            href="https
          ://developers.google.com/terms/api-services-user-data-policy"
          >
            Google User Data Policy
          </a>
          . For more details about anonymization of the data we collect, please
          refer to our <a href={withTrackingParams("/privacypolicy")}>privacy policy.</a>
        </Text>
      </Flex>

     
      <Text size="xl" weight={700} style={{ color: "red" }}>
        Please complete all the steps mentioned above to get your donation
        submission approved.
      </Text>
      <Space h="xl" />
      <Space h="xl" />
      <Title order={2} className="thanks-title">
        Thanks for your contribution by donating your data.
      </Title>
    </Flex>
  );
};

export default Steps;
